module.exports = __webpack_public_path__ + "images/bench-press-with-uni-bands.png";